class Utils {
    public static getUniqueID() {
        while (true) {
            const id = Utils.guidGenerator();
            if (!$("#" + id).length)
                return id;
        }
    }

    static isEmpty(obj) {
        for(let key in obj) {
            if(obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }

    static setBusy(state) {
        if (state) {
            $("#page-busy").css("display", "block");
        }
        else {
            $("#page-busy").css("display", "none");
        }
    }

    static getMeta(name, attribute = 'content') {
        name = document.getElementsByTagName('meta')[name];
        if(name !== undefined){
            name = name.getAttribute(attribute);
            if(name !== undefined){
                return name;
            }
        }
        return null;
    }

    public static guidGenerator() {
        var S4 = function() {
            return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
        };
        return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
    }

    public static elementOverlapping(a, b) {
        function getPositions( elem ) {
            if (!$(elem).length)
                return null;

            let pos, width, height;
            pos = $( elem ).position();
            if (pos.left + 5 > $(window).innerWidth()) {
                let mod = Math.floor(pos.left / $(window).innerWidth());
                pos.left = pos.left - ($(window).innerWidth() * mod);
            }

            let bRect = $(elem)[0].getBoundingClientRect();
            pos = {
                left: bRect.left,
                top: bRect.top
            };

            width = bRect.width;
            height = bRect.height;
            return [ [ pos.left, pos.left + width ], [ pos.top, pos.top + height ] ];
        }

        function comparePositions( p1, p2 ) {
            let r1, r2;
            r1 = p1[0] < p2[0] ? p1 : p2;
            r2 = p1[0] < p2[0] ? p2 : p1;
            return r1[1] > r2[0] || r1[0] === r2[0];
        }

        let pos1 = getPositions( a ),
            pos2 = getPositions( b );

        if (pos1 === null || pos2 === null)
            return false;

        return comparePositions( pos1[0], pos2[0] ) && comparePositions( pos1[1], pos2[1] );
    }
}

export default Utils;